export const ADD_FILE = 'ADD_FILE'
export const GET_FILE = 'GET_FILE'
